import { render, staticRenderFns } from "./aboutAlarm.vue?vue&type=template&id=34025800&"
import script from "./aboutAlarm.vue?vue&type=script&lang=js&"
export * from "./aboutAlarm.vue?vue&type=script&lang=js&"
import style0 from "./aboutAlarm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports